import { render, staticRenderFns } from "./OTPField.vue?vue&type=template&id=0dbca8a0&scoped=true"
import script from "./OTPField.vue?vue&type=script&lang=js"
export * from "./OTPField.vue?vue&type=script&lang=js"
import style0 from "./OTPField.vue?vue&type=style&index=0&id=0dbca8a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbca8a0",
  null
  
)

export default component.exports